import React, { useState } from "react";
import { compose } from "redux";

import { TextField } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import ApiButton from "../../../shared/ui/Api.Button";
import loanSelling from "../../../services/soldLoans/connector";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
  },
}));

const DCALoanItem = ({
  item,
  registerDebtCollectionPayment,
  registerDebtCollectionCreditLoss,
}) => {
  const [moneyToRegister, setMoneyToRegister] = useState(0);

  return (
    <React.Fragment>
      <h3>Register debt payment</h3>
      <br />
      <h4>Remaining: {item.RemainingPrincipal}</h4>
      <h4>Id: {item.OriginatorCreditId}</h4>
      <h4>Next payment number: {item.NextPaymentNumber}</h4>
      <h4>Extra registered: {item.ExtraRegistered}</h4>
      <h4>Credit loss registered: {item.CreditLossRegistered}</h4>
      <hr />
      <TextField
        size="small"
        variant="outlined"
        value={moneyToRegister}
        onChange={(ev) => setMoneyToRegister(ev.target.value)}
        label="Register amount"
      />
      <ApiButton
        buttonLabel={"Register payment"}
        onButtonClick={() =>
          registerDebtCollectionPayment(
            moneyToRegister,
            item.NextPaymentNumber,
            item.OriginatorCreditId,
          )
        }
      />
      <hr />
      <br />
      <ApiButton
        buttonLabel={"Register credit loss"}
        onButtonClick={() =>
          registerDebtCollectionCreditLoss(item.OriginatorCreditId)
        }
      />
    </React.Fragment>
  );
};

const DCALoansComponent = ({
  fetchDCAInfo,
  dca,
  registerDebtCollectionPayment,
  registerDebtCollectionCreditLoss,
}) => {
  const [ssn, setSsn] = useState("");
  const [lsysChecked, setLsysChecked] = useState(true);
  const classes = useStyles();

  const registerPaymentPanel = {
    paddingTop: "20px",
  };

  return (
    <div className="loans-layout body-height content-padding">
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Paper className={classes.paper}>
            <h3>Search with SSN</h3>
            <div style={registerPaymentPanel}>
              <TextField
                size="small"
                variant="outlined"
                value={ssn}
                label="SSN"
                onChange={(ev) => setSsn(ev.target.value)}
              />
              <Checkbox
                checked={lsysChecked}
                onChange={(ev) => setLsysChecked(ev.target.checked)}
                inputProps={{ "aria-label": "primary checkbox" }}
              />
              {"Lsys"}
              <ApiButton
                variant={"contained"}
                color={"primary"}
                buttonLabel={"Search"}
                onButtonClick={() => fetchDCAInfo(ssn, lsysChecked)}
              />
            </div>
            {dca.fetched && dca.data.length > 0 ? (
              dca.data.map((item, index) => (
                <React.Fragment key={index}>
                  <hr />
                  <DCALoanItem
                    item={item}
                    registerDebtCollectionPayment={
                      registerDebtCollectionPayment
                    }
                    registerDebtCollectionCreditLoss={
                      registerDebtCollectionCreditLoss
                    }
                  />
                </React.Fragment>
              ))
            ) : (
              <React.Fragment>
                <hr />
                <span>No loans found</span>
              </React.Fragment>
            )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default compose(loanSelling)(DCALoansComponent);
